import Helper from '../../Helpers/Helper.js';
import NormalType from './NormalType.js';

export default class ObjectType extends NormalType {
  properties;
  required;

  constructor() {
    super(Helper.OBJECT);
    this.properties = {};
    this.required = [];
  }

  addNewProperty(porpName, propObj, isOptional = false) {
    this.properties[porpName] = propObj;
    if (
      propObj.type !== Helper.OBJECT &&
      propObj.type !== Helper.ARRAY &&
      !isOptional
    ) {
      this.required.push(porpName);
    }
  }

  getProperties() {
    return this.properties;
  }

  getPropertiesAt(key) {
    return this.properties[key];
  }
}
